export const isURIScheme = (url: string): boolean => {
  const u = new URL(url);
  if (!(u.protocol === 'http:' || u.protocol === 'https:')) {
    const uriParts = url.split('://');
    return uriParts && uriParts.length === 2;
  }
  return false;
};

// if the protocol is `popeyes://`
export const parseURIScheme = (url: string): string | undefined => {
  const u = new URL(url);
  if (!(u.protocol === 'http:' || u.protocol === 'https:')) {
    const uriParts = url.split('://');
    if (uriParts && uriParts.length === 2) {
      // adding a "/" to prevent routing issues for routes using slug
      return `/${uriParts[1]}`;
    }
  }
  return;
};

// Get the disallowed URLs from the robots.txt file
export const getDisallowedUrls = (robotsTxt: string): string[] =>
  (robotsTxt ?? '').split('\n').reduce((acc, line) => {
    const [key, value] = line.split(':');
    const cleanValue = value?.trim() ?? '';
    const isValid = key.startsWith('Disallow') && cleanValue.startsWith('/');

    return isValid ? [...acc, cleanValue] : acc;
  }, []);
